import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_pineapple_turnover.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganPineappleTurnover() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Pineapple Turnover",
    content_category: "Vegan Menu",
    content_ids: ["vegan_pineapple_turnover"],
    content_type: "vegan_vietnamese_pastries",
    value: 2.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Pineapple Turnover | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Puff pastry turnover filled with fresh, tropical pineapple. Each crunchy bite brings a burst of sweet refreshment to your day."
        />
        <meta
          property="og:title"
          content="Vegan Pineapple Turnover | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Puff pastry turnover filled with fresh, tropical pineapple. Each crunchy bite brings a burst of sweet refreshment to your day."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN PINEAPPLE TURNOVER"
          titleSubHead="$2.50 each"
          detailBody="Puff pastry turnover filled with fresh, tropical pineapple. Each crunchy bite brings a burst of sweet refreshment to your day."
          detailBodyBr="Contains: wheat, soy, almond"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganPineappleTurnover;